import type { FeatureBundle, LazyFeatureBundle } from 'framer-motion';
import { LazyMotion } from 'framer-motion';

type Props = {
  children: React.ReactNode;
  feature: FeatureBundle | LazyFeatureBundle;
};

const FramerMotion = ({ feature, children }: Props) => {
  return <LazyMotion features={feature}>{children}</LazyMotion>;
};

export default FramerMotion;
